import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { RegisteredPersonModel } from '../../admin/models/CompanyModels';
import { localizations } from '../../localization/localization';
import { FilterSettingsModel } from '../../common/models/CommonModels';

type SubmitType = () => void;
type CancelType = () => void;

interface DeleteFilterSettingConfirmProps {
    filterSetting: FilterSettingsModel
}

type Props = DialogPropsBase<SubmitType, CancelType> & DeleteFilterSettingConfirmProps;

const DeleteFilterSettingConfirmation: React.SFC<Props> = (props) => {
    return <Dialog open={props.isOpen}>
        <DialogTitle>{localizations.filterSettings.deletefilterSettingConfirmationTitle}</DialogTitle>
        <DialogContent>
            <Typography paragraph>{localizations.filterSettings.deletefilterSettingQuestion} <strong>{props.filterSetting.name}</strong>?</Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => props.onCancel()}>{localizations.actions.cancel}</Button>
            <Button onClick={() => props.onSubmit()}>{localizations.actions.accept}</Button>
        </DialogActions>
    </Dialog>
}

export default DeleteFilterSettingConfirmation;


// WEBPACK FOOTER //
// ./src/account/forms/DeleteFilterSettingConfirmation.tsx